/**
 * 随着监测的 dom区域 滚动消失，目标 dom 渐显。
 */
function graduallyShow(scrollDom = null, from = null, target = null) {

    handle();
    scrollDom.addEventListener('scroll', handle);

    function handle() {
        // 监测的dom区域
        let top = from.getBoundingClientRect().top
        let section = from.offsetHeight

        if (top > 0) {
            target.style.display = "none"
        } else {
            target.style.display = "block"
        }

        if (top < 0 && top > -section) {
            target.style.opacity = (-top) / section
        }

        if (top < -section) {
            target.style.opacity = 1
        }
    }
}

export {
    graduallyShow
}
